import {DOM, pages} from "./variables"
import {pageLoadedChecker} from "./helpers/page-loaded-checker"
import {setHtmlClasses} from "./helpers/html-classes"

const
  pagesScripts = {
    app: () => import('./app')
  },
  DOMContentLoadedInit = () => {
    pageLoadedChecker()
    setHtmlClasses()
  
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    if (pages.app) {
      pagesScripts.app().then(module => {
        module.app()
      })
    }
  }

export {DOMContentLoadedInit}

